<template>
  <div>
    <v-dialog v-model="show">
      <v-card>
        <v-card-title class="d-flex" style="position: relative" :class="$vuetify.breakpoint.smAndDown ? 'justify-start' : 'justify-center'">
          <h2>{{ editedIndex > -1 ? 'Edit invoice of contractor ' + contractor_id: 'New invoice for contractor ' + contractor_id}}</h2>
          <v-btn icon style="position: absolute; right: 15px; top: 10px;" @click="$emit('close')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container>
            <v-form
              ref="form"
              v-model="valid">
              <v-row justify="space-between" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
                <v-col md="3" cols="12">
                  <v-text-field
                    v-model="editedInvoice.invoice_number"
                    label="Invoice Number"
                    required
                    :disabled="!editPermission"
                  ></v-text-field>
                </v-col>
                <v-col md="3" cols="12">
                  <v-dialog
                    ref="dialogDateInvoice"
                    v-model="modalDateInvoice"
                    :return-value.sync="editedInvoice.date"
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="editedInvoice.date"
                        label="Invoice Date"
                        prepend-icon="event"
                        v-on="on"
                        required
                        :disabled="!editPermission"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="editedInvoice.date"
                      scrollable :max="today"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="blue darken-1" @click="modalDateInvoice = false">Cancel</v-btn>
                      <v-btn text color="blue darken-1" @click="$refs.dialogDateInvoice.save(editedInvoice.date)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
                <v-col md="3" cols="12">
                  <v-dialog
                    ref="dialogDueDate"
                    v-model="modalDueDate"
                    :return-value.sync="editedInvoice.due"
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="editedInvoice.due"
                        label="Due Date"
                        prepend-icon="event"
                        v-on="on"
                        :disabled="!editPermission"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="editedInvoice.due"
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="blue darken-1" @click="modalDueDate = false">Cancel</v-btn>
                      <v-btn text color="blue darken-1" @click="$refs.dialogDueDate.save(editedInvoice.due)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
              </v-row>
            </v-form>
          </v-container>

          <v-divider></v-divider>

          <v-container container--fluid grid-list-xl>
            <v-row align="center" class="text-center">
              <v-col cols="12">
               <h3>Select the routes you want to add to the invoice :</h3>
              </v-col>
            </v-row>
            <v-row justify="space-between" align="center" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
              <v-col md="3" cols="12">
                <v-text-field label="Search..." v-model="search" prepend-icon="search"></v-text-field>
              </v-col>
              <v-col md="1" cols="12">
                <h4 class="text-center">From Date</h4>
              </v-col>
              <v-col md="2" cols="12">
                <v-dialog
                  ref="dialogFrom"
                  v-model="modalFrom"
                  :return-value.sync="fromDate"
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="fromDate"
                      label="From Date"
                      prepend-icon="event"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fromDate"
                    scrollable :max="today"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="blue darken-1" @click="modalFrom = false">Cancel</v-btn>
                    <v-btn text color="blue darken-1" @click="$refs.dialogFrom.save(fromDate)">OK</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>

              <v-col md="1" cols="12">
                <h4 class="text-center">To Date</h4>
              </v-col>
              <v-col md="2" cols="12">
                <v-dialog
                  ref="dialogTo"
                  v-model="modalTo"
                  :return-value.sync="toDate"
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="toDate"
                      label="To Date"
                      prepend-icon="event"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="toDate"
                    scrollable :min="fromDate" :max="today"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="blue darken-1" @click="modalTo = false">Cancel</v-btn>
                    <v-btn text color="blue darken-1" @click="$refs.dialogTo.save(toDate)">OK</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col md="1" cols="12" class="text-center">
                <v-btn text outlined color="blue darken-1" @click="getRoutesFromDates">Search</v-btn>
              </v-col>

            </v-row>
            <v-alert type="warning" :value="searchAlert">
              Please make sure you specified a date range
            </v-alert>
          </v-container>

          <v-divider></v-divider>
          <v-data-table
            :headers="headers"
            :searching="searching"
            :items="renderedRoutes"
            :search="search"
            v-model="selected"
            item-key="id"
            :show-select="!hasBeenChanged"
            @toggle-select-all="selectAllToggle"
          >
            <template v-if="hasBeenChanged" v-slot:item.select="props">
              <input type="checkbox"  :value="props.item" v-model="selected" @click="selectItem(props.item)" :disabled="!props.item.closed || !editPermission" >
            </template>
            <template v-else v-slot:item.data-table-select="{ item, isSelected, select }">
              <v-simple-checkbox
                color="blue"
                :value="isSelected"
                :readonly="item.approval_level !== 'final'"
                :disabled="item.approval_level !== 'final'"
                @input="select($event)"
              ></v-simple-checkbox>
            </template>
            <template v-slot:item.actions="props">
              <v-icon
                small
                @click="editPrice(props.item)"
                :disabled="!props.item.closed"
              >edit
              </v-icon>
            </template>
          </v-data-table>

          <v-container container--fluid grid-list-xl pb-0>
<!--            <v-row justify="space-between" align="center">-->
            <v-row justify="space-between" align="center" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
              <v-col md="2" cols="4" class="flex-column">
                <v-btn text block @click="$refs.fileCreateInvoice.click()" color="warning" :disabled="!editPermission">
                  <div v-if="file ===''">Select a file</div>
                  <div v-else>{{this.file.name}}</div>

                </v-btn>
                <input v-show="false" ref="fileCreateInvoice" type="file" @change="handleFileUpload">
                <!--                      <v-btn text block color="primary" @click="submitFile()">-->
                <!--                        <v-icon left dark>cloud_upload</v-icon>-->
                <!--                        UPLOAD-->
                <!--                      </v-btn>-->
              </v-col>

              <v-col md="2" cols="4">
                <v-col flex-column>
                  <h4 class="text-center">Adjustment</h4>
                  <h4 class="text-center">Can be negative</h4>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="editedInvoice.adjustment"
                    label="Adjustment"
                    prefix="$"
                    type="number"
                    :disabled="!editPermission"
                  ></v-text-field>
                </v-col>
              </v-col>
              <v-col cols="4" md="2">
                <v-switch
                  class="justify-center"
                  color="blue"
                  v-model="editedInvoice.gst"
                  :label="editedInvoice.gst ? 'GST' : 'No GST'"
                  :disabled="!editPermission"
                ></v-switch>
              </v-col>
              <v-col md="3" cols="6" class="text-center">
<!--                Total cost of the invoice : <span class="title">{{getTotalCost | currency}}</span>-->
               <h3>Total cost of the invoice : <span class="raleway-bold">$ {{getTotalCost}}</span></h3>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="justify-center" :class="{'justify-space-around': $vuetify.breakpoint.smAndDown}">
          <v-btn
            text
            @click="$emit('close')"
            color="blue-grey lighten-2"
          >Cancel</v-btn>
          <v-btn
            text
            @click="saveEmit"
            color="blue darken-1"
            :disabled="!editPermission || saving"
            :loading="saving"
          >Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog
      v-model="alertDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          ALERT
        </v-card-title>
        <v-card-text>
          {{message}}
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text color="blue darken-1" @click="alertDialog=false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="editPriceDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          Edit route Nº {{editedItem.id}}
        </v-card-title>
        <v-card-text>
          <v-row justify="space-around">
            <v-col cols="6">
              <v-text-field
                v-on:keyup.esc="close"
                v-on:keyup.enter="saveTotalCost"
                label="Total cost"
                :value="editedItem.invoice_amount"
                v-model="editedItem.invoice_amount"
                prefix="$"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text color="blue-grey lighen-2" @click="close()">Close</v-btn>
          <v-btn text color="blue darken-1" @click="saveTotalCost()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
    import axios from 'axios';
    export default {
        name: "CreateContractorInvoice",
        props: {
            contractor: Object,
            createContractorInvoiceDialog: Boolean,
            editedIndex: Number,
            invoiceId: Number,

        },
        data() {
            return {
                modalDateInvoice: false,
                modalDueDate: false,
                date: null,
                due: null,
                today: new Date().toISOString().substr(0, 10),
                modalFrom: false,
                modalTo: false,
                fromDate: null,
                toDate: null,
                valid: false,
                invoice_number: '',
                search: '', // input search
                searching: false, //input for dates
                alertDialog: false,
                message: '',
                attachment: '',
                file: '',

                adjustment: 0,
                searchAlert: false,
                routes: [],
                invoice_amount: 0,
                editedIndexRoute: -1,
                editedItem: {
                    invoice_amount: 0,
                },
                editPriceDialog: false,
                selected: [],
                editedInvoice: {
                    invoice_number: '',
                    date: null,
                    due: null,
                    fromDate: null,
                    toDate: null,
                    adjustment: 0,
                    attachment: '',
                    gst: false,
                    routes: []
                },
                defaultInvoice: {
                    invoice_number: '',
                    date: null,
                    due: null,
                    fromDate: null,
                    toDate: null,
                    adjustment: 0,
                    attachment: '',
                    gst: false,
                    routes: []
                },
                isSelectable:false,
                disabledCount: 0,
                hasBeenChanged:false,
                saving: false,
            }
        },
        watch: {
            'editedInvoice.date': function () {
                let d = new Date(this.editedInvoice.date);
                d.setUTCDate(d.getUTCDate() - 6);
                let DateInvoiceMinusOneWeek = d.getFullYear() + '-' + (d.getMonth()+1) + '-' + d.getDate();
                this.fromDate = DateInvoiceMinusOneWeek;
                this.toDate = this.editedInvoice.date;
                this.getRoutesFromDates();
            },
        },
        computed: {
            contractor_id() {
              this.editedInvoice.gst = this.contractor.gst_registered;
              return this.contractor.id;
            },
            editPermission() {
              return this.$store.getters['auth/hasPermissionRegionId']('contractors_edit_invoices', this.contractor.region_id) && this.editedIndex <= -1;
              // return this.$store.getters['auth/hasPermissionRegionId']('contractors_edit_invoices', this.contractor.region_id);
            },
            show: {
                get() {
                    return this.createContractorInvoiceDialog;
                },
                set(value) {
                    if (!value) this.$emit('close');
                }
            },
            renderedRoutes() {
              if (this.routes === null || this.routes === undefined) {
                return [];
              }
              this.routes.map(item => {
                if (item.approval_level !== 'final') this.disabledCount += 1
              })
              return this.routes;
            },
            headers() {
                let headers = [
                    // {text: 'Routes', value: 'select', sortable: false, align: 'left'},
                    {text: 'Id', value: 'id', align: 'center', sortable: true},
                    {text: 'Route Name', value: 'name', align: 'center', sortable: true},
                    {text: 'Driver Name', value: 'contractor_user_name', align: 'center', sortable: true},
                    {text: 'PIN', value: 'pin', align: 'center', sortable: true},
                    {text: 'Date', value: 'date', align: 'center', sortable: true},
                    {text: 'Approval level', value: 'approval_level', align: 'center', sortable: true},
                    {text: 'Approved by', value: 'approved_by', align: 'center', sortable: true},
                    {text: 'Penalty ($)', value: 'delivery_penalty', align: 'center', sortable: true},
                    {text: 'Bonus ($)', value: 'delivery_bonus_cost', align: 'center', sortable: true},
                    {text: 'Base Cost ($)', value: 'delivery_base_cost', align: 'center', sortable: true},
                    {text: 'Total Cost ($)', value: 'invoice_amount', align: 'center', sortable: true},
                    {text: 'Actions', value: 'actions', align: 'center', sortable: false}
                ];
                if(this.hasBeenChanged){
                  headers.unshift({text: 'Routes', value: 'select', sortable: false, align: 'left'});
                }
                return headers;
            },
            getTotalCost() {
                let total = 0;
                for (let i in this.selected) {
                    let route = this.findRoute(this.selected[i].id);
                    if (route !== null) total += Number(route.invoice_amount);
                }
                if (this.editedInvoice.adjustment === "" || this.editedInvoice.adjustment === undefined) {
                    return total;
                } else {
                    return (total + parseFloat(this.editedInvoice.adjustment));
                }
            },
        },
        methods: {
            selectAllToggle() {
              if(this.selected.length != this.renderedRoutes.length - this.disabledCount) {
                this.selected = [];
                this.renderedRoutes.forEach(item => {
                  if(item.approval_level === 'final') {
                    this.selected.push(item);
                  }
                });
                this.selectItem();
              } else this.selected = [];
            },
            validate() {
                if (this.$refs.form.validate()) {
                    this.snackbar = true
                }
            },
            reset() {
                this.$refs.form.reset()
            },
            resetValidation() {
                this.$refs.form.resetValidation()
            },
            // @vuese
            // Takes a string argument and displays it in a dialog
            displayMessage(message) {
                this.message = message;
                this.alertDialog = true;
            },
            getRoutePenalty(route) {
                return (route.approval_delivery_penalty === null ? route.delivery_penalty : route.approval_delivery_penalty)
            },
            getRouteBonus(route) {
                return (route.approval_delivery_bonus_cost === null ? route.delivery_bonus_cost : route.approval_delivery_bonus_cost)
            },
            getRouteBaseCost(route) {
                return (route.approval_delivery_base_cost === null ? route.delivery_base_cost : route.approval_delivery_base_cost)
            },
            getRouteCost(route) {
                if (this.invoice) {
                    for (let r of this.invoice.rows) {
                        //check if route is already select and if so use that invoice_amount
                        if (route.id === r.id) {
                            return r.invoice_amount;
                        }
                    }
                }
                return (route.delivery_base_cost === null ? 0 : route.delivery_base_cost * 1)
                    + (route.delivery_bonus_cost === null ? 0 : route.delivery_bonus_cost * 1)
                    - (route.delivery_penalty === null ? 0 : route.delivery_penalty * 1);
            },
            getRoutesFromDates() {
                this.searchAlert = false;
                this.routes = [];
                if ((this.fromDate !== null && this.fromDate !== undefined) && (this.toDate !== null && this.toDate !== undefined)) {
                    this.searching = true;
                    axios.get(process.env.API_URL + '/contractors/' + this.contractor.id + '/routes?from=' + this.fromDate + '&to=' + this.toDate).then((response) => {
                        if (response.status === 200) {
                            this.routes = response.data;
                            if (response.data.length == 0) {
                                this.$store.commit('displaySnackbar', 'No route data for this date range');
                            } else {
                                for (var route of this.routes) {
                                    route.delivery_penalty = parseFloat(this.getRoutePenalty(route)).toFixed(2);
                                    route.delivery_bonus_cost = parseFloat(this.getRouteBonus(route)).toFixed(2);
                                    route.delivery_base_cost = parseFloat(this.getRouteBaseCost(route)).toFixed(2);
                                    route.invoice_amount = parseFloat(this.getRouteCost(route)).toFixed(2);

                                }
                            }
                            this.searching = false;
                        } else {
                            this.message = 'ERROR ' + response.status + 'while getting the routes data.';
                            this.alertDialog = true;
                            this.searching = false;
                        }
                        this.searching = false;
                    })
                        .catch((error) => {
                            console.log(error);
                            this.displayMessage('ERROR ' + error.response.status + 'while getting the routes data.');
                            this.searching = false;
                        })
                } else {
                    this.searchAlert = true;
                }
            },
            // @vuese
            // Resets all the relevant variables to default and closes the editPriceDialog
            close() {
                this.editPriceDialog = false;
            },
            // @vuese
            // Saves the changes of total cost of a route without posting those on the API (just by changing the value on the corresponding object of
            // the array displayed in the table)
            saveTotalCost() {
              if (this.editedIndexRoute > -1) {
                  this.editedItem.invoice_amount = parseFloat(this.editedItem.invoice_amount);
                  this.routes[this.editedIndexRoute].invoice_amount = this.editedItem.invoice_amount;
                  this.updateDataTable();
                  this.hasBeenChanged = true;
              }
              this.close();
            },
            editPrice(item) {
                this.editedIndexRoute = this.routes.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.editPriceDialog = true;
            },
            // @vuese
            // Updated data-table by popping the last element of the route array and reconcatenating it.
            updateDataTable() {
                let last_element = this.routes.pop();
                this.routes = this.routes.concat(last_element);
            },
            // @vuese
            // Handles file upload once a file is selected in the input field of this page.
            handleFileUpload() {
                this.file = this.$refs.fileCreateInvoice.files[0];
                this.$store.commit('displaySnackbar', 'File Loaded');
            },
            findRoute(id) {
                for (let route of this.renderedRoutes) {
                    //just selected
                    if (id === route.id) {
                        return route;
                    }
                }

                if (this.invoice) {
                    for (let route of this.invoice.rows) {
                        //already selected
                        if (id === route.id) {
                            return route;
                        }
                    }
                }
                return null;
            },
            saveEmit() {
              let routes = [];
                for (let i in this.selected) {
                    let route = this.findRoute(this.selected[i].id);
                    if (route !== null) routes.push({route: route.id, amount: route.invoice_amount});
                }
                this.editedInvoice.routes = JSON.stringify(routes);
                if (this.editedIndex > -1) {
                  this.$emit('close');
                } else {
                    // CREATE
                    if (this.editedInvoice.date === null) {
                        this.$store.commit('displaySnackbar', 'Please select an invoice date');
                        return false;
                    } else if (routes.length === 0 && this.editedInvoice.due === null) {
                        this.$store.commit('displaySnackbar', 'Please select at least one route or enter a due date to create the invoice');
                        return false;
                    }
                    let data = new FormData();
                    data.set('date', this.editedInvoice.date);
                    data.set('due', this.editedInvoice.due == null ? null : this.editedInvoice.due);
                    data.set('invoice_number', this.editedInvoice.invoice_number);
                    data.set('adjustment', this.editedInvoice.adjustment);
                    data.set('attachment', this.editedInvoice.attachment);
                    data.set('routes', this.editedInvoice.routes);
                    data.set('gst', this.editedInvoice.gst);
                    if (this.file != null && this.file !== '') {
                      data.append('attachment', this.file);
                    }
                    this.saving = true;
                    axios({
                      method: 'post',
                      url: process.env.API_URL + '/contractors/' + this.contractor.id + '/invoices',
                      data: data,
                      config: {
                        headers: {
                          'Content-Type':
                            'multipart/form-data'
                        }
                      }
                    })
                      .then((response) => {
                          this.editedInvoice = Object.assign({}, response.data);
                          this.invoice = null;
                          this.$store.commit('displaySnackbar', 'Invoice Nº ' + response.data.id + ' created.');
                          this.$emit('close');
                      })
                      .catch((error) => {
                          this.displayMessage('ERROR: ' + (error.response === undefined ? 'Undefined' : error.response.data.error));
                      })
                      .finally(() => {
                          this.saving = false;
                      });
                }
                this.$emit('updateDataTableParent');
            },
            selectItem(item){
              this.editedIndexRoute = this.routes.indexOf(item);
            }

        },
        asyncComputed: {
            async invoice() {
                if (this.invoiceId === undefined || this.invoiceId === null || this.invoiceId < 0) {
                    this.selected = [];
                    this.editedInvoice = Object.assign({}, this.defaultInvoice);
                    return null;
                } else {
                    return await axios.get(process.env.API_URL + '/contractors/' + this.contractor.id + '/invoices/' + this.invoiceId)
                        .then((response) => {
                            this.editedInvoice = Object.assign({}, response.data);
                            this.selected = this.editedInvoice.rows.map(row => row.id);
                            return response.data;
                        })
                        .catch((err) => {
                            this.$store.commit('displaySnackbar', 'ERROR: ' + (err.response === undefined ? 'Unknown error' : err.response.data.error));
                            this.show = false;
                        })
                }
            }
        },

    }
</script>

<style scoped>
  .v-input--selection-controls {
    margin-top: 0;
  }

  input[type=checkbox]{
    height: 25px;
    width: 25px;
  }

  .v-data-table >>> tbody tr:nth-of-type(even) {
    background-color: #f2f5f7;
  }
</style>



// WEBPACK FOOTER //
// src/components/util/Contractors/CreateContractorInvoice.vue